import React, { Component } from 'react';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistDataNotFoundComponent extends Component {
  render() {
    return (
      <div className={'w-full h-full flex flex-col items-center justify-center p-8 bg-white rounded-xl'}>
        <img src={'/icons/empty.svg'} alt='empty' className={'w-[80px] h-[80px]'} />
        <span className={'text-[14px] font-medium pt-2'}>
          {LanguageUtil.get({ id: 'components.watchlistDataNotFoundComponent.title', defaultMessage: 'Data not found' })}
        </span>
        <span className={'text-[12px] w-[200px] text-center text-f-black-3 font-medium'}>
          {LanguageUtil.get({
            id: 'components.watchlistDataNotFoundComponent.description',
            defaultMessage: 'There is no information about dates of registration and designation',
          })}
        </span>
      </div>
    );
  }
}

export default WatchlistDataNotFoundComponent;
